export const ERROR_KEYS_TO_HANDLE = ['TOO_MANY_REQUESTS'];